/* eslint-disable default-case */
import React from "react";
import Select, { SelectProps } from "../Select";
import { Box, Search, TextField, Button } from "./styles";
import { Search as SearchIcon } from "@mui/icons-material";
import Cancle from "./Cancle";

export interface SearchProps {
  option?: SelectProps;
  value: string;
  textHandler: (event: React.ChangeEvent<HTMLInputElement>) => void;
  removeHandler: () => void;
  action: () => void;
  keyHandler: (event: React.KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchComponent = ({
  option,
  value,
  textHandler,
  removeHandler,
  action,
  keyHandler,
}: SearchProps) => {
  const [composing, setComposing] = React.useState(false);
  const [localValue, setLocalValue] = React.useState(value);

  React.useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;

    if (!composing) {
      let validatedValue = newValue;

      switch (option?.value) {
        case "templateId":
          validatedValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
          break;
        case "userId":
          validatedValue = newValue.replace(/[^0-9]/g, "");
          break;
        case "username":
          validatedValue = newValue.replace(/[^a-z0-9_.]/g, ""); // 영소문자, _, 숫자만 허용
          break;
        case "score":
          validatedValue = ""; // score일 때는 입력을 아예 받지 않음
          break;
      }
      // localValue를 validatedValue로 설정하여 화면에 반영
      setLocalValue(validatedValue);
      textHandler({
        ...event,
        target: { ...event.target, value: validatedValue },
      });
    } else {
      // composing 상태일 때는 입력을 그대로 반영
      setLocalValue(newValue);
      textHandler({
        ...event,
        target: { ...event.target, value: newValue },
      });
    }
  };

  const handleCompositionStart = () => {
    setComposing(true);
  };

  const handleCompositionEnd = (
    event: React.CompositionEvent<HTMLInputElement>
  ) => {
    setComposing(false);
    const input = event.target as HTMLInputElement;
    const newValue = input.value;

    let validatedValue = newValue;

    if (option?.value === "templateId") {
      validatedValue = newValue.replace(/[^a-zA-Z0-9]/g, "");
    } else if (option?.value === "userId") {
      validatedValue = newValue.replace(/[^0-9]/g, "");
    } else if (option?.value === "username") {
      validatedValue = newValue.replace(/[^a-z0-9_]/g, ""); // 영소문자, _, 숫자만 허용
    } else if (option?.value === "score") {
      validatedValue = ""; // score일 때는 입력을 아예 받지 않음
    }

    setLocalValue(validatedValue);
    textHandler({
      target: { value: validatedValue },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  if (option) {
    return (
      <Box>
        <Select {...option} />
        <Search>
          <TextField
            value={localValue}
            onChange={handleInputChange}
            onCompositionStart={handleCompositionStart}
            onCompositionEnd={handleCompositionEnd}
            // onKeyPress={(e) => option.value !== "score" && keyHandler(e)}
          />
          {value !== "" && <Cancle removeHandler={removeHandler} />}
          <Button
            onClick={() => option.value !== "score" && action()}
            // onKeyPress={keyHandler}
          >
            <SearchIcon sx={{ color: "#21005D" }} />
          </Button>
        </Search>
      </Box>
    );
  } else {
    return (
      <Box>
        <Search>
          <TextField value={localValue} onChange={textHandler} />
          <Button onClick={action}>
            <SearchIcon sx={{ color: "#21005D" }} />
          </Button>
        </Search>
      </Box>
    );
  }
};

export default SearchComponent;
